import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { SharedService } from './shared.service';
const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class TpaService {

  constructor(private http: HttpClient, private sharedapi: SharedService) { }

  gelAllTpa(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'tpa-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader});
  }

  gelTpaList()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-tpa-list',{headers:webheader});
  }

  getTpa(tpaId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-tpa/'+tpaId,{headers:webheader});
  }

  addTpa(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-tpa',data,{headers:webheader})
  }

  updateTpa(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-tpa',data,{headers:webheader})
  }

  updateTpaStatus(data)
  {
    let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-tpa-status',data,{headers:webheader})
  }

  gelAllTpaInsurance(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'tpa-insurance-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader});
  }

  addTpaInsurance(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-tpa-insurance',data,{headers:webheader})
  }

  getTpaInsurance(tpaInsId)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-tpa-insurance/'+tpaInsId,{headers:webheader});
  }

  updateTpaInsurance(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-tpa-insurance',data,{headers:webheader})
  }

  updateTpaInsuranceStatus(data)
  {
    let webheader = this.sharedapi.getHeaders();
      return this.http.patch(apiUrl+'update-tpa-insurance-status',data,{headers:webheader})
  }

  getTpaInsuranceList()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-tpa-insurance-list',{headers:webheader});
  }

}
